import React from 'react';
import {connect} from 'react-redux';

const AiButton = (props) =>
    <div className="ai-button d-flex justify-content-center btn-spacer">
        {props.current_user &&
            <div className="dropdown d-flex flex-row align-items-center">
                <button
                    className={`btn btn-md btn-primary btn-primary-alt no-arrow btn-chat 
                        ${(props.loading && props.location === 'aiButton') || props.feedback.chat_status !== 'Chat Not Started'
                        ? "disabled" : ""}`}
                    type="button"
                    disabled={props.feedback.chat_status !== 'Chat Not Started' || (props.loading && props.location === 'aiButton')}
                    aria-haspopup="true"
                    onClick={props.handleTick}
                    {...(props.feedback.chat_status !== 'Chat Not Started' ? {
                        'data-toggle': "tooltip",
                        'data-placement': "top",
                        'data-title': "AI Recommended Response currently only available for initial response to customer"
                    } : {})}
                >
                    {(props.loading && props.location === 'aiButton') &&
                        <>
                            <div className={'aiButton-spinner-wrapper'}>
                                <div className={'aiButton-wrapper'}>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span className={'aiButton-spinner-seconds'}>{props.seconds}</span>
                                </div>
                            </div>
                        </>
                    }
                    <span>
                        <svg className='ml-1 mr-1' width="7" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M4.15.025c.101.036.19.106.253.202.063.095.097.21.097.328v2.778h2c.091 0 .181.028.26.08a.537.537 0 0 1 .183.219.608.608 0 0 1-.033.575l-3.5 5.555a.509.509 0 0 1-.249.208c-.1.038-.21.04-.311.004a.505.505 0 0 1-.253-.201.598.598 0 0 1-.097-.329V6.666h-2a.463.463 0 0 1-.26-.08.536.536 0 0 1-.183-.218.608.608 0 0 1 .033-.576L3.59.237a.509.509 0 0 1 .249-.208c.1-.038.21-.039.311-.003Z" fill="#3775B7"/>
                        </svg>
                        {__('Preview AI Response')}
                    </span>
                </button>
            </div>
        }
    </div>

function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        loading: state.loading,
        location: state.loading_location,
        loading_data: state.loading_data,
        feedback_id: state.selected_feedback,
        alert: state.alert,
        current_user: state.current_user,
        chatAnyway: state.chatAnyway,
    }
}

export default connect(mapStateToProps)(AiButton);
